import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { registerHarmoneyPortalIcons } from './components/harmoneyportalicon';
import MainPageModel from './modules/mainpagemodel';
import {
	setRootModuleState,
	getQueryString,
	webapi,
	DateUtils,
	REPORTED_EXCEPTION,
	Windows
} from 'ps-gui';
import { registerModules } from './modules/moduleregistration';
import {
	checkLogoutImminentIn,
	clearLogoutImminent,
	initializeSession,
	setLoggedOut
} from './data/session';
import { processException } from './data/exceptions';
import { initializeLookups } from './data/lookup';
import { GlobalContextModel } from './data/globalcontext';
import { pushState } from './data/history';
import IsrcProtocolModel from './modules/isrcprotocol/isrcprotocolmodel';
import { getUserAdminDetailModel } from './modules/useradminmodel';
// import LabelAdminModel from './modules/label/labeladminmodel';
// import LabelModel from './modules/label/labelmodel';
// import SubmissionAdminModel from './modules/submissionadminmodel';
// import AffirmationSubmissionModel from './modules/affsub/affirmationsubmissionmodel';
// import RecordingProtocolAdminModel from './modules/recordingprotocol/recordingprotocoladminmodel';
// import RecordingProtocolDetailModel from './modules/recordingprotocol/recordingprotocoldetailmodel';
// import MyRecordingsModel from './modules/myrecordingsmodel';
// import UserAdminModel from './modules/useradminmodel';


DateUtils.setRawDateToJSON();

console.log('hi_1.24.4');

let baseUrl;
function initBaseUrl() {
	function getBase() {
		if (window.location.origin.indexOf('localhost') > 0) {
			// return 'https://portal-test.intergram.cz/sojuz-portal-rest';
			return 'http://asdev02.raventia.net:8088/sojuz-portal-rest-dev2';
			//return 'http://localhost:8080/sojuz-portal-rest';
		} else if (window.location.origin.indexOf('desktop-r1i49f1') > 0) {
			return 'http://localhost:8080/sojuz-portal-rest';
		}
		const pathName = window.location.pathname || '';
		if (pathName.indexOf('test2') > 0) {
			return '/sojuz-portal-rest-test2';
		} else if (pathName.indexOf('dev2') > 0) {
			return '/sojuz-portal-rest-dev2';
		} else if (pathName.indexOf('reg1') > 0) {
			return '/sojuz-portal-rest-reg1';
		} else {
			return '/sojuz-portal-rest';
		}
	}
	baseUrl = getBase();
}

initBaseUrl();

function getDefaultLanguage() {
	const res = localStorage.getItem('languageId');
	if (res) {
		return res;
	}
	const langs = window.navigator.languages || [];
	if (langs.some(lng => {
		lng = lng.toLowerCase();
		return lng.indexOf('cs') >= 0 || lng.indexOf('cz') >= 0 || lng.indexOf('sk') >= 0;
	})) {
		return 'CZ';
	} else {
		return 'EN';
	}
}

async function setDefaultLanguage() {
	let gc = new GlobalContextModel();
	gc = await gc.setLanguageId(getDefaultLanguage());
	gc.apply();
}

webapi.setDecorateUrl(url => {
	return baseUrl + url;
}).setDefaultMethod('post');

webapi.setProcessException(processException);

webapi.addListener(url => {
	if (url && url.indexOf('lanu_') < 0) {
		clearLogoutImminent();
		checkLogoutImminentIn(60);
	}
});

registerHarmoneyPortalIcons();
registerModules();

async function loginToken2SessionToken(token) {
	let res = await webapi.execute('/api/proc/api_user/getPartyLoginSession', {
		token
	});
	if (res === REPORTED_EXCEPTION) {
		return null;
	}
	return res.token;
}

const DUMMY_PAGE = false;
async function run() {
	window.basePath = window.location.origin + window.location.pathname;
	window._ps_basePath = window.basePath;
	await setDefaultLanguage();
	ReactDOM.render(<App />, document.getElementById('root'));

	if (DUMMY_PAGE) {
		const origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		setLoggedOut();
		setRootModuleState(new MainPageModel().getState());
		return;
	}

	let rootModel = null;

	const wid = getQueryString('wid');
	if (wid) {
		//setNologout(true);
		Windows.initialize(wid);
		const params = Windows.getParams();
		await initializeSession(params.token);
		await initializeLookups();
		if (params.entityName === 'user') {
			rootModel = getUserAdminDetailModel();
			rootModel = await rootModel.loadDetail(params.entityId);
		}

		if (rootModel) {
			setRootModuleState(rootModel.getState());
		}
		return;
	}

	if (getQueryString('ua')) {
		return;
	}

	const st = getQueryString('st');
	const loginToken = getQueryString('s');
	let standaloneModule = getQueryString('sam');
	let sessionToken = null;
	let origPathName = '';
	if (st) {
		sessionToken = st;
	} else if (loginToken) {
		origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		console.log(origPathName);
		sessionToken = await loginToken2SessionToken(loginToken);
	} else {
		origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		console.log('origPathName = ', origPathName);
		// window.history.replaceState('home', '', '/');

		const storedStts = localStorage.getItem('stts');
		let storedSt = localStorage.getItem('st');
		if (storedSt === 'null') {
			storedSt = null;
		}
		console.log('stored - st = ', storedSt, ', stts = ', storedStts);
		if (storedSt && storedStts) {
			const now = new Date().getTime();
			const elapsed = ((now - parseInt(storedStts)) / 1000);
			console.log('elapsed = ', elapsed);
			if (elapsed <= 600) {
				sessionToken = storedSt;
			}
		}
	}
	pushState('home', '');


	await initializeSession(sessionToken);
	if (sessionToken) {
		await initializeLookups();
	}

	console.log(window.location.pathname);

	// standaloneModule = 'ip';
	console.log('sam = ', standaloneModule);

	if (standaloneModule === 'ip' || (origPathName || '').indexOf('isrc') >= 0) {
		rootModel = new IsrcProtocolModel();
	} else {
		rootModel = new MainPageModel();
	}
	// rootModel = new RecordingProtocolAdminModel();
	// rootModel = new MyRecordingsModel();
	// rootModel = await rootModel.openPermanentCatalogDetail(1004481, 79102);
	// rootModel = new RecordingProtocolDetailModel();
	// rootModel = await rootModel.load(81);
	// rootModel = new MainPageModel();
	// rootModel = new AffirmationSubmissionModel();
	// rootModel = new UserAdminModel();
	// rootModel = new MainPageModel();
	// rootModel = new SubmissionAdminModel();
	// rootModel = new LabelModel();
	// rootModel = new LabelAdminModel();
	setRootModuleState(rootModel.getState());

}


run();

if (module.hot) {
	module.hot.accept();
}

window.webapi = webapi;

window.addEventListener('dragenter', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
}, false);

window.addEventListener('dragover', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
});

window.addEventListener('drop', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
});
